import { getFieldWidth } from 'app/shared/componentsRestyled/common/formGenerator/FormGenerator.utils';
import _ from 'lodash';

import { TagColor } from 'constants/ui';

import { loanFeeCicFormFields } from './LoanFeeCicForm.config';

export const getStyles = theme => {
  return {
    override: {
      '& .autocomplete-chip-reselect': {
        backgroundColor: _.get(theme, ['tag', TagColor.RED]),
      },
    },
    header: {
      '& > *': {
        margin: '24px 8px',
      },
      '& :nth-child(1)': {
        width: getFieldWidth({
          widthInColumns: loanFeeCicFormFields.name.inputProps.widthInColumns,
          numberOfColumns: 3,
        }),
      },
      '& :nth-child(2)': {
        width: getFieldWidth({
          widthInColumns: loanFeeCicFormFields.amount.inputProps.widthInColumns,
          numberOfColumns: 3,
        }),
      },
    },
  };
};
